import styled from 'styled-components';
import { device } from '../../../breakpoints';

export const StyledLiveBadge = styled.div`
    position: absolute;
    left: 10px;
    top: 10px;
    width: calc(100% - 16px);

    @media ${device.GteSmall} {
        top: 15px;
        left: 15px;
    }
`;
